import { DefaultService } from '@/services/DefaultService';


export default class ApiWebHookAutenticacaoHeaderService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    updateSituacao(id) {
        return this._http.post(`${this._env}/apiwebhookautenticacaoheader/updatesituacao`, id, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.post(`${this._env}/apiwebhookautenticacaoheader/delete`, id, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}